import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DrawerModule } from 'primeng/drawer';
import { InputTextModule } from 'primeng/inputtext';
import { ListCoursesResponseModel } from '../models/course.model';
import { TenantContextService } from '../../auth/data-access/tenant-access.service';
import { AuthService } from '../../auth/data-access/auth.service';
import { LayoutService } from '../../../app/layout/service/layout.service';
import { CourseService } from '../data-access/course.service';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-course-selection',
  imports: [CommonModule, DrawerModule, InputTextModule, FormsModule, TagModule],
  templateUrl: './course-selection.component.html',
  styleUrl: './course-selection.component.scss',
})
export class CourseSelectionComponent implements OnInit {
  public authService = inject(AuthService);
  public tenantContextService = inject(TenantContextService);
  public layoutService = inject(LayoutService);
  public courseService = inject(CourseService);

  public courses = signal<ListCoursesResponseModel[]>([]);
  public filteredCourses = signal<ListCoursesResponseModel[]>([]);

  public currentCourseIdComputed = computed(() => {
    return this.tenantContextService.selectedCourse()?._id;
  });

  public visible = computed(() => {
    return this.layoutService.layoutState().courseSidebarVisible;
  });

  ngOnInit(): void {
    const isSuperAdmin = this.authService.isSuperAdminComputedSignal();

    this.courseService
      .getCourses({
        page: 1,
        limit: 200,
        sortBy: 'createdAt',
        sortOrder: 'desc',
      }, isSuperAdmin)
      .subscribe({
        next: (response) => {
          if (response?.data) {
            this.courses.set(response.data);
            this.filteredCourses.set(response.data);

            const currentUser = this.authService.authUserComputedSignal();
            const preferredCourse = this.filteredCourses()?.find(x => x._id === currentUser?.preferredCourse);
            if (preferredCourse) {
              this.tenantContextService.setCourse(preferredCourse);
              this.tenantContextService.setCompany(preferredCourse.companyId);
            } else {
              this.tenantContextService.setCourse(response.data[0]);
              this.tenantContextService.setCompany(response.data[0]?.companyId);
            }
          }
        },
      });
  }

  onCourseFilter($event: Event): void {
    const input = $event.target as HTMLInputElement;
    const value = input?.value || '';

    if (value.length > 0) {
      const filtered = this.courses().filter((course: any) =>
        course?.displayName?.toLowerCase().includes(value.toLowerCase())
      );
      this.filteredCourses.set(filtered);
    } else {
      this.filteredCourses.set(this.courses());
    }
  }

  onCourseSelect(course: ListCoursesResponseModel): void {
    this.tenantContextService.setCourse(course);
    this.tenantContextService.setCompany(course.companyId);
    this.onDrawerHide();
  }

  public onDrawerHide() {
    this.layoutService.layoutState.update((state) => ({
      ...state,
      courseSidebarVisible: false,
    }));
  }
}